export const colors = [
    "#000000",
    "#0000FF",
    "#FF0000",
    "#800080",
    "#00FF00",
    "#8080FF",
    "#FF8080",
    "#FF00FF",
    "#00FFFF",
];

export const names = [
    "Time(S)",
    "Left",
    "Right",
    "Center",
    "LFE",
    "Surr left",
    "Surr right",
    "Surr back left",
    "Surr back right",
];

export const namesShort = ["S", "L", "R", "C", "LFE", "SL", "SR", "SBL", "SBR"];
